import {
    NinchatActionType,
    NinchatUpdateUserMessagesAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateUserMessages = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateUserMessagesAction}`,
    async (arg: NinchatActionParams<NinchatUpdateUserMessagesAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateUserMessagesAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)

